import detect_mobile from './detect_mobile';
import storage from './storage';

export default {
  detect_mobile,
  storage
};



// WEBPACK FOOTER //
// ./src/libs/index.js